import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { CardActions, List, ListItem, styled, Paper, Divider } from '@mui/material'
import { Box, IconButton, Button, ListItemText, Tooltip } from '@mui/material'
import { show, codeTree } from '../../redux/slices/Drawer/drawerRight'
import { updateFeatures } from '../../redux/slices/Tree/treeFeatures'
import { getPropertiesByID } from '../../services'
import { QrCode2Outlined, Cancel as CancelIcon } from '@mui/icons-material'
import CodeQrModal from '../../components/CodeQRModal'
import ContainerPopover from './ContainerPopover'
import ChipCustomTg from '../ChipCustomTg'
import './Popup.css'

const colorPopupPrimary = 'var(--color-green)'
const fontFamilyType = 'var(--font-family)'
const colorPopupLabel = '#6A6A6A'
const colorPopupValue = '#1B1C37'
const paddingInlineBody = 16
// Change PROPERTIES_DEFAULT if the default properties in the geojson are increased
const PROPERTIES_DEFAULT = 4

const Header = styled(Paper)(() => ({
  backgroundColor: colorPopupPrimary,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: '3.6em',
  paddingLeft: '16px',
  borderRadius: '0.8em 0.8em 0 0',
}))
const LatLogCdTree = styled(Paper)(() => ({
  minHeight: '2.8em',
  display: 'flex',
  alignItems: 'center',
  boxShadow: 'none',
  textAlign: 'initial',
}))
const Text = styled('div')(() => ({
  fontFamily: fontFamilyType,
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '13px',
  lineHeight: '12px',
  textAlign: 'center',
  color: colorPopupLabel,
}))
const ButtonCustom = styled(Button)({
  height: '26px',
  backgroundColor: colorPopupPrimary,
  textTransform: 'capitalize',
  color: '#fff',
  fontSize: '12px',
  '&:hover': {
    backgroundColor: '#006373',
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: colorPopupPrimary,
    borderColor: colorPopupPrimary,
  },
})
const styleTextHeader = {
  textAlign: 'center',
  width: '100%',
  fontWeight: 700,
  fontSize: '15px',
  lineHeight: '15px',
  color: '#fff',
  paddingTop: 0.7,
}

const light = {
  green: { bg: '#25a52e', c: '#FFF' },
  yellow: { bg: '#EDD317', c: '#000' },
  red: { bg: '#D83020', c: '#FFF' },
}

const styleChip = [
  {
    id: 2,
    props: type => ({
      label: 'Enfermedad',
      badgeBackground: light?.[type]?.bg,
      badgeColor: light?.[type]?.c,
    }),
  },
  {
    id: 6,
    props: type => ({
      label: 'Problema físico',
      badgeBackground: light?.[type]?.bg,
      badgeColor: light?.[type]?.c,
    }),
  },
  {
    id: 7,
    props: type => ({
      label: 'Riesgos',
      badgeBackground: light?.[type]?.bg,
      badgeColor: light?.[type]?.c,
    }),
  },
  {
    id: 4,
    props: type => ({
      label: 'Plaga',
      badgeBackground: light?.[type]?.bg,
      badgeColor: light?.[type]?.c,
    }),
  },
  { id: 8, props: () => ({ label: 'Recomendación', badgeBackground: '#c4ed17' }) },
]

export default function PopupContent({ treeId, coordinates, code }) {
  const dispatch = useDispatch()
  const [showQR, setShowQR] = useState(false)
  const _treeState = useSelector(state => state.treeFeatures)
  const { features: data } = _treeState.data || {}

  const isAuth = useSelector(state => state.login.authenticated?.auth)

  if (!(data || []).length) console.log('No se ha cargando las caracteristicas...')

  const featureTreeCode = data.filter(obj => obj.properties?.id === treeId)
  const treeAttributes = featureTreeCode?.[0]?.properties?.attributes || []
  const inconveniences = featureTreeCode?.[0]?.properties?.inconveniences || []
  const scientificName = (featureTreeCode?.[0]?.properties?.specie || {}).name || ''
  const classifier = (featureTreeCode?.[0]?.properties?.specie || {}).classifier || ''
  const pseudonymName =
    ((featureTreeCode?.[0]?.properties?.specie || {}).pseudonym || [])[0]?.name || ''

  function getIndexOfFeature(id) {
    let idFeatureState = 0
    data.forEach((obj, key) => {
      if (obj.properties?.id === id) idFeatureState = key
    })
    return idFeatureState
  }

  function chipForDiseases(obj) {
    const length = obj.attributes.length
    const type = length > 5 ? 'red' : length > 3 ? 'yellow' : 'green'
    const content = length
    return { type, content }
  }

  function chipForPests(obj) {
    const length = obj.attributes.length
    const type = length > 5 ? 'red' : length > 3 ? 'yellow' : 'green'
    const content = length
    return { type, content }
  }

  function getValueForMetaFid(treeAttributes, targetMetaFid) {
    const item = treeAttributes.find(attr => attr?.metaFid === targetMetaFid)
    return item ? item.value : null
  }

  function calcularNivelDeRiesgo(obj, straightnessValor) {
    if (!Boolean(straightnessValor)) return {}

    let countRisk = 0
    let straightness = 1
    let derriboValida = false
    let rishValue = null
    let numRiskTotal = 0
    let diseaseIssues = 0
    let pestIssues = 0

    // Mapeo de rectitud
    const weightStraightness = {
      recto: 1,
      torcido: 1.05,
      inclinado: 1.45,
      muyinclinado: 1.5,
    }

    // Grupos de riesgo con IDs
    const riskGroups = [
      { ids: [62, 63, 64], weight: 0.7 }, // Caída
      { ids: [65, 66, 67], weight: 0.1 }, // Afección
      { ids: [68, 69, 70], weight: 0.05 }, // Interferencia circulación
      { ids: [71, 72, 73], weight: 0.05 }, // Infraestructura
      { ids: [74, 75, 76], weight: 0.1 }, // Redes eléctricas
    ]
    // Niveles numéricos por valor textual (puedes ajustar esto según tu escala)
    const riskLevelMap = { bajo: 1, medio: 2, alto: 3 }
    const diseaseSet = new Set([22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 86])
    const pestSet = new Set([39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 88])

    // Obtener IDs y valores de riesgo
    const inconveniences = obj.attributes || []
    if (!Boolean(inconveniences?.length)) return {}

    for (const inc of inconveniences) {
      const key = Object.keys(inc)[0] // e.g. 'rsgoCaida'
      const data = inc[key] // e.g. { id: 63, value: 'Bajo' }
      const id = data.id
      if (data?.id === 83) derriboValida = true

      const valor = data.value?.toLowerCase().replace(/\s+/g, '') // "bajo", "medio", ...

      if (diseaseSet.has(id)) diseaseIssues++
      if (pestSet.has(id)) pestIssues++

      if (riskLevelMap[valor] !== undefined)
        for (const group of riskGroups)
          if (group.ids.includes(id)) {
            countRisk += riskLevelMap[valor] * group.weight
            numRiskTotal++
            break
          }
    }

    // Rectitud transformada
    const rectitudKey = straightnessValor.toLowerCase().replace(/\s+/g, '')
    straightness = weightStraightness[rectitudKey]

    if (numRiskTotal === 5 && straightness !== undefined) {
      rishValue = countRisk * straightness
      if (derriboValida) rishValue += 0.5
      if (diseaseIssues > 5) rishValue += 0.5
      if (pestIssues > 5) rishValue += 0.5
    }

    const level = rishValue < 1.6 ? 'Bajo' : rishValue < 2.3 ? 'Medio' : 'Alto'

    return {
      level,
      rishValue: rishValue.toFixed(2),
      straightness,
      countRisk: countRisk.toFixed(2),
    }
  }

  function chipForPotentialRisks(obj) {
    const valueFusteRectitud = getValueForMetaFid(treeAttributes, 14)
    const risk = calcularNivelDeRiesgo(obj, valueFusteRectitud)

    if (!Object.keys(risk).length) return { type: null, content: null }

    const type =
      risk.level === 'Bajo' ? 'green' : risk.level === 'Medio' ? 'yellow' : 'red'
    return { type, content: risk.level.charAt(0) }
  }

  function chipForPhysicalProblems(obj) {
    const length = obj.attributes.length
    const type = length > 4 ? 'red' : length > 2 ? 'yellow' : 'green'
    const content = length
    return { type, content }
  }

  function chipForSuggestions(obj) {
    const length = obj.attributes.length
    const type = length > 5 ? 'red' : length > 3 ? 'yellow' : 'green'
    const content = length
    return { type, content }
  }

  const chipOptions = {
    2: obj => chipForDiseases(obj),
    4: obj => chipForPests(obj),
    6: obj => chipForPhysicalProblems(obj),
    7: obj => chipForPotentialRisks(obj),
    8: obj => chipForSuggestions(obj),
  }

  const specie = featureTreeCode[0]?.properties?.specie || {}
  const site = featureTreeCode[0]?.properties?.site || {}

  const wordsLength = `${scientificName + classifier}`.length > 36
  const drawerHeight = wordsLength ? '5em' : '3.8em'

  let featuresBasic = {
    family: { label: 'Familia', value: specie?.family?.name || 'No encontrada' },
    site: { label: 'Sitio', value: site.name || 'No encontrada' },
    section: { label: 'Sección', value: site.section || 'No encontrada' },
  }

  const handleCodeQrModal = () => setShowQR(true)
  const handleCloseAction = () => setShowQR(false)
  const handleActiveDrawerRight = () => {
    dispatch(show(true))
    dispatch(codeTree(getIndexOfFeature(treeId)))
  }

  useEffect(() => {
    if (!featureTreeCode?.length) return
    const dontfetch =
      Object.keys(featureTreeCode?.[0]?.properties)?.length > PROPERTIES_DEFAULT
    if (dontfetch) return

    getPropertiesByID(treeId).then(propertiesByID => {
      if (!Object.keys(propertiesByID).length > PROPERTIES_DEFAULT) {
        console.log('No se pudo cargar los datos. Intente más tarde.')
        return
      }
      dispatch(
        updateFeatures({
          someId: getIndexOfFeature(treeId),
          someValue: propertiesByID,
        })
      )
    })
  })

  if (!treeAttributes?.length) return

  return (
    <Box sx={{ minWidth: '25em', boxShadow: 'none' }}>
      <Header style={{ minHeight: drawerHeight }}>
        <Text sx={styleTextHeader}>
          {pseudonymName && (
            <Box pb={0.3}>
              <span style={{ textTransform: 'uppercase' }}>{pseudonymName}</span>
              <br />
            </Box>
          )}
          <span style={{ fontStyle: 'italic', fontWeight: 550, paddingBottom: 1 }}>
            {scientificName}
          </span>
          {wordsLength ? <br /> : null}
          <span style={{ fontSize: 12 }}>
            {Boolean(classifier) ? ` ${classifier}` : ''}
          </span>
        </Text>
        <IconButton
          aria-label="close"
          size="small"
          sx={{ px: 1, paddingRight: '6px', marginBottom: '10px' }}>
          <CancelIcon sx={{ fill: '#a8f446', width: 20, height: 16 }} />
        </IconButton>
      </Header>
      {!showQR ? (
        <div style={{ paddingInline: paddingInlineBody, paddingTop: 6 }}>
          <ContainerPopover attributes={featureTreeCode?.[0].properties?.attributes} />
          <Divider sx={{ mt: 0.2, mb: 0.6 }} light={true} />

          <List sx={{ py: 0 }}>
            {Object.keys(featuresBasic).map(key => (
              <ListItem
                key={`feature-${key}`}
                component="div"
                disablePadding
                sx={{
                  minHeight: 18,
                  justifyContent: 'initial',
                  py: 0,
                }}>
                <ListItemText sx={{ marginTop: '2px' }}>
                  <div style={{ display: 'flex', flexFlow: 'row nowrap' }}>
                    <Text sx={{ flexGrow: 1, textAlign: 'start' }}>
                      {featuresBasic[`${key}`].label}:
                    </Text>
                    <Text sx={{ color: colorPopupValue, flexGrow: 6 }}>
                      {featuresBasic[`${key}`].value}
                    </Text>
                  </div>
                </ListItemText>
              </ListItem>
            ))}
          </List>
          <Divider light={true} sx={{ mt: 0.2 }} />
          <Box
            sx={{
              display: 'flex',
              flexFlow: 'row wrap',
              justifyContent: 'space-evenly',
              pt: 1,
            }}>
            {inconveniences.map((obj, i) => {
              let element = null
              if (obj.id === 8 && !Boolean(isAuth)) return element
              const res = chipOptions[obj.id]?.(obj)
              styleChip.forEach((style, j) => {
                if (obj.id === style.id) {
                  element = (
                    <div key={`Chip-${i}-${j}`}>
                      <ChipCustomTg
                        badgeContent={res?.content}
                        {...style.props(res?.type)}
                      />
                    </div>
                  )
                }
              })
              return element
            })}
          </Box>

          <CardActions sx={{ pt: 1, px: 0 }}>
            <Box sx={{ width: 100 }}>
              <LatLogCdTree>
                <Text
                  sx={{
                    textAlign: 'start',
                    lineHeight: '14px',
                    fontSize: '12px',
                  }}>
                  Código:
                  <br />
                  <span style={{ color: colorPopupValue }}>{code}</span>
                </Text>
              </LatLogCdTree>
            </Box>
            <Box sx={{ alignSelf: 'center', mr: 8 }}>
              <Link to={`${code}`} style={{ textDecoration: 'none' }}>
                <ButtonCustom
                  onClick={handleActiveDrawerRight}
                  variant="contained"
                  size="small"
                  sx={{ width: 84 }}>
                  <p
                    style={{ fontFamily: fontFamilyType, fontSize: 14, fontWeight: 600 }}>
                    Ver <span style={{ textTransform: 'lowercase' }}>más</span>
                  </p>
                </ButtonCustom>
              </Link>
            </Box>
            <Box sx={{ cursor: 'pointer', alignSelf: 'end' }} onClick={handleCodeQrModal}>
              <Tooltip
                title="Ver CodeQR"
                placement="bottom"
                followCursor
                enterDelay={50}
                leaveDelay={100}>
                <QrCode2Outlined sx={{ fontSize: 26 }} />
              </Tooltip>
            </Box>
          </CardActions>
        </div>
      ) : (
        <CodeQrModal onClose={handleCloseAction} treeId={code} isAuth={isAuth} />
      )}
    </Box>
  )
}
